// utils/api/ScaffoldApi.js
import { getAuthHeaders } from './ApiUtils';

/**
 * Start the display phase for a scaffold stage.
 * Returns { success, stage_id, display_message, questions, selected_question_ids }
 */
export async function scaffoldStart({
  classId,
  sectionId,
  moduleId,
  environmentId,
  component = 'ERD',
  stageId = 'stage_1',
  feedbackId,
  componentContext,
}) {
  const res = await fetch('/api/scaffold/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({
      class_id: classId,
      section_id: sectionId,
      module_id: moduleId || sectionId,
      environment_id: environmentId,
      component,
      stage_id: stageId,
      feedback_id: feedbackId,
      component_context: componentContext,
    }),
  });
  return res.json();
}

/**
 * Send a single Q&A turn to a qa_interaction stage.
 * Returns { success, answer }
 */
export async function scaffoldQA({
  classId,
  sectionId,
  moduleId,
  environmentId,
  component = 'ERD',
  stageId,
  feedbackId,
  componentContext,
  question,
  chatHistory = [],
}) {
  const res = await fetch('/api/scaffold/qa', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({
      class_id: classId,
      section_id: sectionId,
      module_id: moduleId || sectionId,
      environment_id: environmentId,
      component,
      stage_id: stageId,
      feedback_id: feedbackId,
      component_context: componentContext,
      question,
      chat_history: chatHistory,
    }),
  });
  return res.json();
}

/**
 * Submit student answers and get the adaptive concept excerpt.
 * Returns { success, correctness, concept_excerpt, next_options, next_stage_id }
 */
export async function scaffoldRespond({
  classId,
  sectionId,
  moduleId,
  environmentId,
  component = 'ERD',
  stageId,
  feedbackId,
  componentContext,
  selectedQuestionIds,
  studentAnswers,
  questionTexts,   // { resource_id: filled_question_text } — for feedback log display
}) {
  const res = await fetch('/api/scaffold/respond', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({
      class_id: classId,
      section_id: sectionId,
      module_id: moduleId || sectionId,
      environment_id: environmentId,
      component,
      stage_id: stageId,
      feedback_id: feedbackId,
      component_context: componentContext,
      selected_question_ids: selectedQuestionIds,
      student_answers: studentAnswers,
      question_texts: questionTexts || {},
    }),
  });
  return res.json();
}
